// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";
import {
  ProjectStatus,
  UpdatePolicy,
} from "./types";


export default __t.row({
  id: __t.u32().primaryKey(),
  projectName: __t.string().name("project_name"),
  displayName: __t.string().name("display_name"),
  description: __t.string(),
  get status() {
    return ProjectStatus;
  },
  createdBy: __t.identity().name("created_by"),
  createdAt: __t.timestamp().name("created_at"),
  updatedAt: __t.timestamp().name("updated_at"),
  autoUpdate: __t.bool().name("auto_update"),
  isPublic: __t.bool().name("is_public"),
  get updatePolicy() {
    return UpdatePolicy.name("update_policy");
  },
  assetReadScopes: __t.option(__t.array(__t.string())).name("asset_read_scopes"),
});
